import OrganizationViewModel from "@/domain/OrganizationViewModel";
import ClientBase from "../ClientBase";
import SubscriptionViewModel from "@/domain/SubscriptionViewModel";
import SubscriptionUsageRecordViewModel from "@/domain/SubscriptionUsageRecordViewModel";

class OrganizationClient extends ClientBase{

    async getSubscriptionsByOrganizationId(organizationId){
        const data = await this.get(`api/v1/subscriptions/organizations/${organizationId}`);
        return data?.map(subscription => new SubscriptionViewModel(subscription)) ?? [];
    }

    async getCurrentOrganizationSubscription(organizationId) {
        const data = await this.get(`api/v1/subscriptions/organizations/${organizationId}/current`);
        return data ? new SubscriptionViewModel(data) : null;
    }

    async getSubscriptionUsageRecords(organizationId, period = null) {
        const url = period
            ? `api/v1/subscriptions/organizations/${organizationId}/usage?period=${encodeURIComponent(period)}`
            : `api/v1/subscriptions/organizations/${organizationId}/usage`;
        const data = await this.get(url);
        return data?.map(record => new SubscriptionUsageRecordViewModel(record)) ?? [];
    }

    async getOrganizationByAuthZeroOrgId(orgId) {
        const data = await this.get(`api/v1/organizations/authzero/${orgId}`);
        return data ? new OrganizationViewModel(data) : null;
    }

    async getSasTokenData(organizationId){
        return await this.get(`api/v1/organizationSaS/${organizationId}`);
    }
}

export default new OrganizationClient();